import type { ToolUseItem } from '@heidi/agents/contracts';
import type { IntlShape } from 'react-intl';

import {
  renderStandardExportToolUse,
  type OpenExportDocumentPayload,
} from './shared/exportDocumentPreview';

export const renderGenerateExcelToolUse = (
  item: ToolUseItem,
  intl: IntlShape,
  onOpenDocumentExport?: (payload: OpenExportDocumentPayload) => void
): JSX.Element | null =>
  renderStandardExportToolUse(
    item,
    intl,
    {
      artefactType: 'excel',
      titleFallback: { id: 'pjArtXls02', defaultMessage: 'Excel export' },
    },
    onOpenDocumentExport
  );
